import { createSignal } from '@verclam/pulsar';

const roleToDeleteSignal = createSignal<number | null>(null);

export const setRoleToDelete = (roleId: number | null): void => {
	roleToDeleteSignal.value = roleId;
};

export default roleToDeleteSignal;
